import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1.5">
          {i > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          {item.to ? (
            <Link to={item.to} className="cursor-pointer whitespace-nowrap transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="whitespace-nowrap text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}